/**
 * Parse string with placeholders
 *
 * @param {string} stringWithPlaceHolder
 * @param {string[]} sortedValues
 * @returns {string}
 */

export const replacePlaceHolder = (stringWithPlaceHolder: string, ...sortedValues: string[]): string => {
  let parsedString = stringWithPlaceHolder;

  sortedValues.forEach(function (value, index) {
    if (typeof value === "undefined" || value === null || value === "") {
      value = "-";
    }
    if (typeof value !== "undefined" && value !== null) {
      parsedString = parsedString.replace(`{${index}}`, value);
    }
  });
  parsedString = parsedString.replace(new RegExp("{[0-9]*}", "g"), "");

  return parsedString;
};
